import translations from "app/assets/files/translations/report-the-death-to-ica.json";
import { ReportingADeathGuidesList, Topics, TopicType } from "app/components/templates/Guide/__common__/Topic";
import MultiPageGuide from "app/components/templates/Guide/MultiPageGuide";
import { useGlobalLanguageState } from "app/utils/internationalization/GlobalLanguageProvider";
import { ITranslatedObject } from "app/utils/internationalization/TranslationPageRenderer";
import { useEffect, useState } from "react";

const Index = (): JSX.Element => {
	const [language] = useGlobalLanguageState();
	const [translatedObjects, setTranslatedObjects] = useState<ITranslatedObject[] | undefined>(undefined);

	useEffect(() => {
		const newTranslatedObjects = translations[language];
		setTranslatedObjects(newTranslatedObjects);
	}, [language]);

	return (
		<MultiPageGuide
			relatedGuides={ReportingADeathGuidesList}
			currentTopic={Topics[TopicType.WhenDeathHappens]}
			currentGuideTitle={ReportingADeathGuidesList.overseas}
			currentStep={5}
			translatedObjects={translatedObjects}
		/>
	);
};

export default Index;
